// extracted by mini-css-extract-plugin
export default {"Stwelfth":"Stwelfth_Stwelfth__Vj3FE","wrap":"Stwelfth_wrap__VGOqV","title":"Stwelfth_title__SPbA2","desc":"Stwelfth_desc__nO1BS","pic":"Stwelfth_pic__bbuRb"};